import { BaseResolverService } from '@abstract/base-resolver.service';
import { Injectable } from '@angular/core';
import { LabsApiService } from '@api/labs.api.service';
import { Router } from '@angular/router';

/**
 * Резолвер данных лаборатории
 */

@Injectable()
export class LabsResolverService extends BaseResolverService {
    constructor(
        service: LabsApiService,
        router: Router
    ) {
        super(service, router);
    }
}
